import Api from './Api'
import { store } from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}
export default class FileService {
  constructor() {}

  static async selectFile() {
    // https://stackoverflow.com/a/63773257
    let lock = false;
    return new Promise((resolve, reject) => {
      let input = document.createElement('input');
      input.id = +new Date();
      input.style.display = 'none';
      input.type = 'file';
      document.body.appendChild(input);

      input.addEventListener('change', () => {
        lock = true;
        let file = input.files[0];
        resolve(file);
        // make sure nothing else deleted the input element before trying to remove it
        if (document.getElementById(input.id)) {
          document.body.removeChild(document.getElementById(input.id));
        }
      }, { once: true });

      window.addEventListener('focus', () => {
        setTimeout(() => {
          if (!lock && document.getElementById(input.id)) {
            reject('no file selcted');
            document.body.removeChild(document.getElementById(input.id))
          }
        }, 300)
      }, { once: true })

      input.click();
    });
  }

  static downloadDataAsFile(data, filename) {
    if (!data) {
      throw 'No data to download';
    }

    if (!(data instanceof Blob)) {
      data = new Blob([data]);
    }

    if (window.navigator && window.navigator.msSaveBlob) { // for IE/edge
      window.navigator.msSaveBlob(data, filename);
    } else { // for Non-IE (chrome, firefox etc.)
      let a = document.createElement('a');
      let url = window.URL.createObjectURL(data);
      a.href = url;
      a.download = filename;

      document.body.append(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }
  }

  static upload(file) {
    if (!file) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      let url = `/admin/api/v1/orgs/${getOrgId()}/file`;
      let data = new FormData();
      data.append('file', file);
      try {
        let response = await new Api().post(url, data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  }
}